import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  driverLicenseTitle: {
    defaultMessage: 'TLC Driver License Number',
    id: 'us_tlc_driver_license_number_title',
    description: 'US TLC Driver License number field title',
  },
  addressTitle: {
    defaultMessage: 'Home address',
    id: '4TxXBI',
    description: 'Field title for address input',
  },
});
